import { all, call, put, takeEvery } from "redux-saga/effects";
import API from "../../../Utils/api";
import { notifyPromise } from "../../../Utils/Helper";
import { momumpayWithdrawalRequestSuccess, momumpayWithdrawalRequestFailure } from "../../Action";
import { MONUMPAY_WITHDRAWAL_REQUEST } from "../../Action/actionTypes";

function* monumpayPayoutRequest(action) {
    try {
        const { data } = yield notifyPromise(
            API.post("/monumpay-withdrawal", action?.payload?.monumpayPayload)
        );
        if (action?.payload?.callback) {
            yield call(action.payload.callback, data);
        }
        if (data?.meta?.code === 200) {
            yield put(momumpayWithdrawalRequestSuccess(data?.data));

        } else {
            yield put(momumpayWithdrawalRequestFailure());
        }
    } catch (error) {
        yield put(momumpayWithdrawalRequestFailure());
    }
}

export function* watchMonumpayWithdrawalRequestAPI() {
    yield takeEvery(MONUMPAY_WITHDRAWAL_REQUEST, monumpayPayoutRequest);
}

export default function* rootSaga() {
    yield all([watchMonumpayWithdrawalRequestAPI()]);
}
